import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("talent");

  const handleLogin = () => {
    localStorage.setItem("userType", userType);
    navigate(`/dashboard/${userType}`);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-orange-50 to-white">
      <div className="card w-full max-w-md">
        <h2 className="text-2xl text-center text-orange-600 mb-6 font-semibold">
          Sign In to Creerlio
        </h2>
        <div className="space-y-4">
          <select
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
            className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
          >
            <option value="talent">Talent</option>
            <option value="business">Business</option>
          </select>

          <button
            onClick={handleLogin}
            className="btn-primary w-full"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
